const InfoColumnHeader = ({ title }) => (
  <abbr title={title}>
    <i className="fas fa-question-circle"></i>
  </abbr>
);

export default InfoColumnHeader;
